import React from 'react';
import classNames from 'classnames';

import Icon from 'shared/components/icon';

import styles from './school-header.module.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const SchoolHeader = ({children, className}: Props) => (
  <div className={classNames(styles.header, className)}>
    <Icon iconType="school" className={styles.school} /> {children}
  </div>
);

export default SchoolHeader;
